import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'flxHighlight',
})
export class FlxHighlightPipe implements PipeTransform {
  constructor() {}

  transform(input: any, searchTerm: string): string {
    if (!searchTerm?.length) {
      return input
    }
    const regExp = new RegExp(`(${searchTerm})(?!.*\\1)`, 'gi')
    return input.replace(regExp, `<span class="highlight">$1</span>`)
  }
}
